import React from "react";

import { SubtleBadge } from "components/Badge";
import { VisibilitySection } from "components/DetailedSaleLotModal/AdvancedDrafting/Visibility";
import { FormCollapse } from "components/Form";
import { Row } from "components/Layout";

type IntegrationCollapseProps = {
  isOpen: boolean;
  onToggle: () => void;
  consignmentId: string;
  namespace?: string;
};

export const IntegrationCollapse = React.memo(
  ({
    isOpen,
    onToggle,
    consignmentId,
    namespace,
  }: IntegrationCollapseProps) => {
    const header = (
      <Row>
        <SubtleBadge>Integrations</SubtleBadge>
      </Row>
    );
    return (
      <FormCollapse
        isOpen={isOpen}
        onToggle={onToggle}
        header={header}
        id="collapse-media"
      >
        <VisibilitySection
          consignmentId={consignmentId}
          namespace={namespace}
        />
      </FormCollapse>
    );
  },
);
